require('./fields-modal.component.scss');

import {
  getTableViewByType
} from '../../facts/table-view';

export class FieldsModalController {

  constructor(
    $scope,
    $modalInstance,
    purpose,
    RouterService,
    LocalStorageService,
    CurrentFilterService,
    CurrentModelService,
  ) {
    this.storageKey = 'SELECTED_FIELDS';
    this.$scope = $scope;
    $scope.okButton = gettext('Ок');
    $scope.cancelButton = gettext('Cancel');
    this.$modalInstance = $modalInstance;
    this.LocalStorageService = LocalStorageService;
    this.router = RouterService;
    this.lang = this.router.PermissionService.selectedLang;
    this.filter = CurrentFilterService.filter;
    this.dims = CurrentModelService.model._dimensions;
    this.measures = CurrentModelService.model.cubes[0].measures;
    this.$scope.isDefaultSelection = true;
    this.factKey = 'fact';
    // this.fields = Object.keys(this.router.CurrentFilterDataService.filterData.filterData[0]);
    $scope.fields = this.getFields();
    $scope.cancel = () => this.cancel();
    // $scope.getFieldSelected = (field) => this.getFieldSelected(field);
    $scope.getFieldUnselected = field => this.getFieldUnselected(field);
    $scope.setLevelSelected = level => this.setLevelSelected(level);
    $scope.setFieldSelected = field => this.setFieldSelected(field);
    $scope.removeSelection = selection => this.removeSelection(selection);
    $scope.setAllSelection = bool => this.setAllSelection(bool);
    $scope.setDefaultSelection = () => this.setDefaultFields();

    let selections;
    if (purpose === 'CSV') {
      $scope.ok = () => this.okCSV();
      $scope.modalTitle = gettext('Выберите поля для выгрузки в CSV');
      selections = this.LocalStorageService.getItem(this.storageKey);
    } else if (purpose === 'TABLE') {
      $scope.modalTitle = gettext('Выберите поля для вывода в таблице');
      $scope.ok = () => this.okTable();
      if (this.filter.fields && this.filter.fields.length) selections = this.filter.fields.join(',');
    } else $scope.ok = () => null;

    this.$scope.isDefaultSelection = !selections;
    if (!this.$scope.isDefaultSelection) {
      $scope.selectedItems = selections.split(',').map(s => {
        const [parentKey, levelKey] = s.split('.');
        return this.getSelectedItem(parentKey, levelKey);
      }).filter(item => !!item);
    } else {
      $scope.selectedItems = [];
      this.setDefaultFields();
    }
  }

  setDefaultFields() {
    this.setAllSelection(false);
    const viewMode = getTableViewByType(
      this.filter.viewModeType(),
      this.filter.filters,
    );
    if (!viewMode.columns || !viewMode.columns.length) return;
    viewMode.columns.map(v => {
      const [parentKey, levelKey] = v.factKey.split('.');
      this.addSelection(parentKey, levelKey);
    });
    this.$scope.isDefaultSelection = true;
  }

  setAllSelection(bool) {
    this.$scope.fields.map(f => {
      if (f.levels) f.levels.map(l => {
        l.selected = bool;
        if (bool) this.addSelection(l.parentKey, l.key);
      });
      else {
        f.selected = bool;
        this.addSelection(f.key);
      }
    });
    if (!bool) this.$scope.selectedItems = [];
    this.$scope.isDefaultSelection = false;
  }

  getSelectedItem(parentKey, levelKey) {
    if (!levelKey) {
      levelKey = parentKey;
      parentKey = this.factKey;
    }
    const res = {};
    const field = this.$scope.fields.find(f => f.key === parentKey);
    if (!field) return null;
    res.parentKey = field.key;
    res.parentLabel = field.label;
    if (levelKey && field.levels) {
      const level = field.levels.find(l => l.key === levelKey);
      if (level) {
        res.levelKey = level.key;
        res.levelLabel = level.label;
        if (level.lang) res.lang = level.lang;
        level.selected = true;
      }
    } else if (!field.levels) field.selected = true;
    return res;
  }

  renameLabel(name, label) {
    if (name === 'file_size') return gettext('Размер файла');
    if (name === 'activity_time') return gettext('Длительность');
    if (name === 'call_duration') return gettext('Время разовора / страницы');
    return label;
  }

  getFields() {
    const isLevels = dim => dim.levels && dim.levels.length && (dim.levels.length > 1 ||
      (dim.levels[0].attributes && dim.levels[0].attributes.length > 1));

    return this.dims.filter(dim => isLevels(dim))
      .map(dim => ({
        key: dim.name,
        label: dim.label,
        selected: false,
        levels: dim.levels.reduce((accLevel, level) => {
            if (level.attributes && level.attributes.length > 1) {
              return accLevel.concat(level.attributes.map(arrt => ({
                key: arrt.name,
                lang: arrt.locales && arrt.locales.length ? this.lang : null,
                parentKey: dim.name,
                label: arrt.label,
                selected: false,
              })).filter(f => f.label));
            }
            return accLevel.concat({
              key: level.key,
              lang: level.attributes && level.attributes[0] && level.attributes[0].locales &&
                level.attributes[0].locales.length ? this.lang : null,
              parentKey: dim.name,
              label: level.label,
              selected: false,
            });
          }, [])
          .filter(f => !((f.parentKey === 'agent_dialog' && f.key === 'contact') ||
            (f.parentKey === 'agent_dialog' && f.key === 'domain'))),
      }))
      .concat({
        key: this.factKey,
        label: gettext('Факт'),
        selected: false,
        levels: this.dims.filter(dim => !isLevels(dim)).map(dim => ({
            key: dim.name,
            parentKey: this.factKey,
            label: dim.label,
            selected: false,
          }))
          .concat(this.measures.filter(m => m.name !== 'idle_time' && this.dims.every(d => d.name !== m.name))
            .map(m => ({
              key: m.name,
              parentKey: this.factKey,
              label: this.renameLabel(m.name, m.label),
              selected: false,
            })))
      });
  }

  setLevelSelected(level) {
    level.selected = true;
    this.addSelection(level.parentKey, level.key);
  }

  setFieldSelected(field) {
    if (field.levels) field.levels.map(level => {
      level.selected = true;
      this.addSelection(level.parentKey, level.key);
    });
    else {
      field.selected = true;
      this.addSelection(field.key);
    }
  }

  // getFieldSelected(field) {
  //   if (field.levels) return field.levels.some(level => level.selected);
  //   return field.selected;
  // }

  getFieldUnselected(field) {
    if (field.levels) return field.levels.some(level => !level.selected);
    return !field.selected;
  }

  findSelectionIndex(parentKey, levelKey) {
    return this.$scope.selectedItems.findIndex(s => s.parentKey === parentKey &&
      (s.levelKey === levelKey || (!levelKey && !s.levelKey)));
  }

  setLevelUnselected(parentKey, levelKey) {
    const field = this.$scope.fields.find(f => f.key === parentKey);
    if (!field) return;
    if (field.levels && levelKey) {
      const level = field.levels.find(l => l.key === levelKey);
      if (level) level.selected = false;
    } else if (!field.levels) {
      field.selected = false;
    }
    this.$scope.isDefaultSelection = false;
  }

  removeSelection(selection) {
    const i = this.findSelectionIndex(selection.parentKey, selection.levelKey);
    if (i === -1) return;
    this.$scope.selectedItems.splice(i, 1);
    this.setLevelUnselected(selection.parentKey, selection.levelKey);
    this.$scope.isDefaultSelection = false;
  }

  addSelection(parentKey, levelKey) {
    if (!levelKey) {
      levelKey = parentKey;
      parentKey = this.factKey;
    }
    const i = this.findSelectionIndex(parentKey, levelKey);
    if (i === -1) this.$scope.selectedItems.push(this.getSelectedItem(parentKey, levelKey));
    this.$scope.isDefaultSelection = false;
  }

  getSelections(withLang) {
    return this.$scope.selectedItems.map(s => s.parentKey === this.factKey ?
      s.levelKey + (withLang && s.lang ? '.' + s.lang : '') :
      `${s.parentKey}.${s.levelKey + (withLang && s.lang ? '.' + s.lang : '')}`).join(',');
  }

  okCSV() {
    if (this.$scope.isDefaultSelection) this.LocalStorageService.removeItem(this.storageKey);
    else this.LocalStorageService.setItem(this.storageKey, this.$scope.selectedItems ? this.getSelections(false) : null);
    this.router.openNewWindow(`&limit=${this.filter.customLimit ? this.filter.customLimit : 1000000000}` +
      this.$scope.selectedItems ? `&fields=${this.getSelections(true)}` : '');
    this.$modalInstance.close();
  }

  okTable() {
    if (this.$scope.isDefaultSelection) {
      this.router.fields = null;
      if (this.filter.fields) {
        this.filter.fields = '';
        this.filter.changed();
      }
    } else if (this.$scope.selectedItems) this.router.fields = this.getSelections(false);

    this.$modalInstance.close(true);
  }

  cancel() {
    this.$modalInstance.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/layout/fields/fields-modal.component.js